import { render } from "./DesktopHeader.vue?vue&type=template&id=59f4f91c&scoped=true&ts=true"
import script from "./DesktopHeader.vue?vue&type=script&lang=ts"
export * from "./DesktopHeader.vue?vue&type=script&lang=ts"

import "./DesktopHeader.vue?vue&type=style&index=0&id=59f4f91c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f4f91c"]])

export default __exports__